import script from "./ResultLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultLoader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__